export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Incomplete'
    },
    unique: [],
    lang: {
        name: 'Play Incomplete',
        category: ['User', 'Plays'],
        description: 'Whether the play was marked as incomplete.',
        views: ['list', 'sheet'],
    },
    filters: ['play.status']
}
